export function validateBehaviorInstructions(
  isDefaultAgent: boolean,
  advancedInstructionMode: boolean,
  value: string | undefined
): Promise<void> {
  if (isDefaultAgent) return Promise.resolve();
  if (advancedInstructionMode) return Promise.resolve();
  if (String(value || '').trim()) return Promise.resolve();
  return Promise.reject(new Error('Agent instructions are required.'));
}

export function validateSuccessCriteria(
  isDefaultAgent: boolean,
  criteria: {
    mode: 'specific' | 'custom';
    infoCollected: boolean;
    noHuman: boolean;
    positive: boolean;
    selected: string[];
    customText: string;
  }
): Promise<void> {
  if (isDefaultAgent) return Promise.resolve();

  const { mode, infoCollected, noHuman, positive, selected, customText } =
    criteria;

  if (mode === 'custom') {
    if (!customText.trim()) {
      return Promise.reject(
        new Error('Success criteria is required: enter custom success text.')
      );
    }
    return Promise.resolve();
  }

  if (!infoCollected && !noHuman && !positive) {
    return Promise.reject(
      new Error(
        'Success criteria is required: select at least one option under Specific success criteria.'
      )
    );
  }

  if (infoCollected && selected.length === 0) {
    return Promise.reject(
      new Error(
        'Success criteria: select at least one item under "Information successfully collected".'
      )
    );
  }

  return Promise.resolve();
}

export function shouldPromptForInstructionsBeforeSave(
  isDefaultAgent: boolean,
  collect: unknown
): boolean {
  if (isDefaultAgent) return false;
  const collectIds = Array.isArray(collect) ? collect : [];
  return collectIds.length === 0;
}
